"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formError = _interopRequireDefault(require("../../assets/icons/formError.svg"));

var _closeError = _interopRequireDefault(require("../../assets/icons/close-error.svg"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.snackbar-container {\n  font-family: \"OpenSansRegular\"; }\n\n.snackbar {\n  box-sizing: border-box;\n  opacity: 1;\n  background-color: transparent;\n  border: 0.0625rem solid #e15c5c;\n  color: #e15c5c;\n  width: 100%;\n  display: flex;\n  padding: 1rem;\n  gap: 1rem;\n  align-items: center; }\n\n.snackbar-title {\n  display: inline-block;\n  font-size: 0.875rem;\n  font-weight: 700; }\n\n.details-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  flex: 1; }\n\n.snackbar-image-title {\n  display: flex;\n  align-self: flex-start; }\n\n.snackbar-close-icon {\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n  align-self: flex-start; }\n\n.snackbar-image-title img {\n  width: 1.5rem;\n  height: 1.5rem; }\n\n.error-list-container {\n  overflow-y: auto;\n  word-wrap: break-word;\n  font-size: 0.875rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem; }\n";
  var fileName = "compone_snackbar";
  var element = document.querySelector("style[data-sass-component='compone_snackbar']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var Snackbar = function Snackbar(_ref) {
  var title = _ref.title,
      errorList = _ref.errorList,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? null : _ref$maxWidth,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? null : _ref$maxHeight,
      _ref$allowClosing = _ref.allowClosing,
      allowClosing = _ref$allowClosing === void 0 ? false : _ref$allowClosing,
      onClose = _ref.onClose;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isClosed = _useState2[0],
      setIsClosed = _useState2[1];

  var handleClose = function handleClose(e) {
    e.stopPropagation();
    setIsClosed(true);

    if (typeof onClose === 'function') {
      onClose();
    }
  };

  if (isClosed) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.snackbarContainer,
    "data-testid": _constants.classes.snackbarContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.snackbar
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.imageTitle
  }, /*#__PURE__*/_react.default.createElement("img", {
    role: _constants.imageRole,
    src: _formError.default,
    alt: title
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.detailsContainer
  }, title && /*#__PURE__*/_react.default.createElement("span", {
    className: _constants.classes.title
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.errorListContainer,
    style: {
      maxWidth: maxWidth,
      maxHeight: maxHeight
    }
  }, errorList && errorList.length ? errorList.map(function (element, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      "data-testid": _constants.errorRole
    }, element);
  }) : null)), allowClosing && /*#__PURE__*/_react.default.createElement("button", {
    className: _constants.classes.closeIcon,
    onClick: handleClose
  }, /*#__PURE__*/_react.default.createElement("img", {
    role: 'close-snackbar',
    src: _closeError.default,
    alt: 'Close'
  }))));
};

Snackbar.propTypes = {
  title: _propTypes.default.string,
  errorList: _propTypes.default.array,
  allowClosing: _propTypes.default.bool,
  maxWidth: _propTypes.default.string,
  maxHeight: _propTypes.default.string,
  onClose: _propTypes.default.func
};
var _default = Snackbar;
exports.default = _default;